import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActiveDriver } from '../types';

@Pipe({
  name: 'userFromPhone',
})
export class UserFromPhonePipe implements PipeTransform {
  constructor() {}

  // tslint:disable-next-line
  transform(phone: string): Observable<ActiveDriver> {
    return of({} as ActiveDriver);
  }
}
